<template>
  <div v-if="content" class="parc-info">
    <div :style="setBackground(content.img)" class="parc-img"></div>
    <div class="parc-content-w">
      <div class="parc-content" :style="bgColor">
        <h2 v-html="content.title"></h2>
        <div v-html="content.text"></div>
      </div>
    </div>
  </div>
</template>

<script>
import backgroundFollow from "@/mixins/backgroundFollow.js";
export default {
  mixins: [backgroundFollow],
  props: {
    content: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      id: this.$route.params.id
    };
  },
  methods: {},
  computed: {
    bgColor() {
      return {
        backgroundColor: this.id === "sainte-foy" ? "#e96e0f" : "#436c90"
      };
    }
  }
};
</script>

<style lang="scss">
.parc-content {
  &::-webkit-scrollbar {
    width: 22px;
    margin-right: 10px;
  }

  &::-webkit-scrollbar-track {
    margin: 10px 0;
    box-shadow: inset 0 0 10px 10px rgba(0, 0, 0, 0.3);
    border: solid 8px transparent;
    border-radius: 10px;
  }

  &::-webkit-scrollbar-thumb {
    box-shadow: inset 0 0 10px 10px #fff;
    border: solid 8px transparent;
    border-radius: 10px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #fff;
  }
}
.parc-info {
  height: 600px;
  width: 100%;
  position: relative;
  display: flex;
  clip-path: polygon(100% 0, 100% 90%, 50% 100%, 0 90%, 0 0);
  .parc-content-w {
    position: relative;
    z-index: 1;
    width: $content-width;
    max-width: $max-width;
    margin: auto;
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
    height: 80%;
  }
  .parc-content {
    //background-color: $stefoy;
    color: #fff;
    padding: 25px 30px;
    overflow: auto;
   
    line-height: 1.2;
    width: 490px;
    border-radius: 20px;
    box-shadow: 0px 0px 15px 3px rgba(0, 0, 0, 0.15);
    height: 100%;
    white-space: pre-wrap;
    h2 {
      line-height: 1;
      padding-bottom: 20px;
       font-size: 22px;
    }
  }
  .parc-img {
    height: 100%;
    width: 100%;
    position: absolute;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
  }
}
#parc-page {
  .parc-info {
    .parc-content {
      ::-webkit-scrollbar {
        width: 5px !important;
      }

      /* Track */
      ::-webkit-scrollbar-track {
        border-radius: 10px;
      }

      /* Handle */
      ::-webkit-scrollbar-thumb {
        background: $primary-D;
        border-radius: 10px;
      }

      /* Handle on hover */
      ::-webkit-scrollbar-thumb:hover {
        background: $primary-D2;
      }
    }
  }
}
</style>
